<template>
  <div>
    <b-card no-body>
      <b-tabs active-nav-item-class="font-weight-bold" card>
        <b-tab  
          :title="$t('parametrics.activeModules')" 
          title-link-class="text-dark" 
          active
          >
          <modules-table :modules="activeModules"/>
        </b-tab>
        <b-tab  
          :title="$t('parametrics.inactiveModules')" 
          title-link-class="text-dark" 
          
          >
          <modules-table :modules="inactiveModules"/>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import trainingService from '../../services/training.service.js';
import { handleApiError } from "../../services/error.service";
import ModulesTable from './modulesTable.vue';

export default {
  computed: {
    isAdmin() {
      let isAdmin = false;
      let userInfo = this.$store.state.userInfo
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "ADMIN" || userInfo.roles[i].name == 'TRAINING_ADMIN') {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    isMod() {
      let isMod = false;
      let userInfo = this.$store.state.userInfo
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAIN_MOD") {
          isMod = true;
        }
      }
      return isMod;
    },
    isTrainer() {
      let isTrainer = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAINER") {
          isTrainer = true;
        }
      }
      return isTrainer;
    }
  },
  components: {
    ModulesTable
  },
  mounted() {
    this.getModulesByCriteria(true, 'FLEX_MODULE');
    this.getModulesByCriteria(false, 'FLEX_MODULE');
  },
  data() {
    return {
      oldModules: null,
      activeModules: null,
      inactiveModules: null
    }
  },
  methods: {
    emitError(errorMessage) {
      this.$emit('error:api', errorMessage);
    },
    emitSuccess(successMessage) {
      this.$emit('success', successMessage);
    },
    getModulesByCriteria(active, type) {
      trainingService.getModulesByCriteria(active, type).then(
        (response) => {
          this.$log.debug(`${active} ${type} modules`)
          this.$log.debug(response.data)
          if(type == 'OLD_MODULE') {
            this.oldModules = response.data;
          } else if (active) {
            this.activeModules = response.data;
          } else {
            this.inactiveModules = response.data;
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>
